import React, { useEffect } from 'react'
import AgentHeader from '../../AgentHeader'
import PrivacyPolicyContent from '../../../shared/auth/PrivacyPolicyContent'

export default function PrivacySection (): JSX.Element {
    useEffect(() => {
        document.getElementById('header_privacy_section')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'

        })
    }, [])
    return (
        <>
            <div
                className="page d-flex flex-column flex-row-fluid fs-5"
                id='header_privacy_section'
            >

                <AgentHeader
                    active="Privacy Policy"
                />

                <div className="content d-flex flex-column flex-fill p-0 m-4">

                    <div className="w-100 mw-450px mx-auto">
                        <div className="card shadow-sm mb-4">
                            <div className="card-body p-4">
                                <PrivacyPolicyContent/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
